import React, {Component} from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";

import Loader from "../../Loader/Loader";
import ConfirmModal from "./ConfirmModal";
import EditModal from "./EditModal";

import classnames from "classnames";
import styles from "./DataBox.scss";

export default class Employer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      employer_data: undefined,
      datum: undefined,
      data_schema: undefined,

      showConfirmModal: false,
      showEditModal: false
    }
  }

  componentDidMount() {
    this.updateTable()
  }

  updateTable = () => {
    console.log("Updating Employers...");
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .get("/api/admin/getallemployers")
      .then(res => {
        this.setState({
          employer_data: res.data
        });
      })
      .catch(e => console.log(e));
  };

  getNewDataSchema = () => {
    var data = { ...this.state.employer_data[0] };
    var data_schema = {};

    Object.entries(data).map(ent => {
      if (ent[0] === '_id') {
        return null;
      } else if (typeof ent[1] === "string") {
        data_schema[ent[0]] = "";
        return null;
      } else if (typeof ent[1] === "boolean") {
        data_schema[ent[0]] = false;
        return null;
      } else if (typeof ent[1] === "number") {
        data_schema[ent[0]] = 0;
        return null;
      } else {
        data_schema[ent[0]] = "";
        return null;
      }
    });
    this.showEditModal(data_schema);
  };

  getDataSchema = data => {
    var data_schema = {};

    Object.entries(data).map(ent => {
      if (false) {
        return null;
      } else {
        data_schema[ent[0]] = ent[1];
      }
      return null;
    });
    this.showEditModal(data_schema);
  };

  showConfirmModal = datum => {
    this.setState({ showConfirmModal: true, datum: datum });
  };

  hideConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  showEditModal = datum => {
    this.setState({ showEditModal: true, datum: datum });
  };

  hideEditModal = () => {
    this.setState({ showEditModal: false });
  };

  deleteData(datum, type) {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .post("/api/admin/deleteemployer", datum)
      .then(res => {
        this.updateTable();
      })
      .catch(e => console.log(e));
  }

  updateOrAdd(datum, type) {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .post("/api/admin/updateoraddemployer", datum)
      .then(res => {
        this.updateTable();
      })
      .catch(e => console.log(e));
  }

  render() {
    if ( !this.state.employer_data) {

      return <Loader/>;
    }
    else {

      return(
        <div className={styles.dataBox}>
          <ConfirmModal
            show={this.state.showConfirmModal}
            handleClose={this.hideConfirmModal}
            data={this.state.datum}
            deleteData={this.deleteData}
            updateTable={this.updateTable}
          />
          <EditModal
            show={this.state.showEditModal}
            handleClose={this.hideEditModal}
            data={this.state.datum}
            updateOrAdd={this.updateOrAdd}
            updateTable={this.updateTable}
          />
          <button
            className={classnames("btn btn-info", styles.modalButtons)}
            onClick={() => this.getNewDataSchema()}
          >
            <FontAwesomeIcon className={styles.cursor} icon={faPlus} />
          </button>
          <div className={classnames("table-responsive", styles.table)}>
            <table className="table table-striped w-auto">
              <thead>
                <tr>
                  <th>First Name </th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone Number </th>
                  <th>Company </th>
                  <th>Website</th>
                  <th>Timestamp</th>
                  <th>Active</th>
                  <th className="textCenter">Edit</th>
                  <th className="textCenter">Delete</th>
                </tr>
              </thead>
              <tbody>
                {this.state.employer_data.map((row, i) => {
                  return(
                    <tr key={i}>
                    <td>{row.first_name} </td>
                    <td>{row.last_name} </td>
                    <td>{row.email} </td>
                    <td>{row.phone_number} </td>
                    <td>{row.company}</td>
                    <td><a target="_blank" href={"http://"+row.website}>{row.website}</a></td>
                    <td>{row.timestamp}</td>
                    <td>{row.active === false ? "Not Active": "Active"}</td>
                    <td className="textCenter">
                    <FontAwesomeIcon
                    className={styles.cursor}
                    onClick={() => this.getDataSchema(row)}
                    style={{ color: "#323643" }}
                    icon={faEdit}
                    />
                    </td>
                    <td className="textCenter">
                    <FontAwesomeIcon
                    className={styles.cursor}
                    onClick={() => this.showConfirmModal(row)}
                    style={{ color: "#323643" }}
                    icon={faTrash}
                    />
                    </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>

      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Admin/Employer.js